import React from 'react'
import './Footer.css'

function footer() {
    return (
        <div className="footer-copyright">
            <div className="container">
                <div className="row">
                    <div className="text-footer">
                        <p>Copyright Diseñado por Douglas Guacaran © 2022. Todos los derechos reservados.</p>
                    </div>
                </div>
            </div>
        </div>
    )
    }

export default footer